import React, { useState } from "react";
import { ReactComponent as SelectFile } from "../../assets/icons/select-file.svg";

const FileInput = ({ onFileChange }) => {
  const [fileName, setFileName] = useState("No file chosen");

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    onFileChange(file);
    setFileName(file ? file.name : "No file chosen");
  };

  return (
    <div className="flex flex-col gap-2">
      <p className="text-sm text-gray-600">
        Attach any relevant documents such as photos or documents here. We
        accept any .pdf, .doc, .docx, .jpg, .jpeg & .png files. Maximum file
        size is 5MB
      </p>
      <div className="flex flex-row items-center gap-2  ">
        <label className="flex items-center w-fit gap-2 px-4 py-2 border border-green-500 rounded-full cursor-pointer text-green-600 hover:bg-green-50">
          <SelectFile />
          <span className="text-[#50A85A] text-base md:text-xl font-bold">
            Choose File
          </span>
          <input
            type="file"
            className="hidden"
            onChange={handleFileChange}
            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
          />
        </label>
        <span className="text-[#BDBDBD] text-base md:text-lg font-bold">
          {fileName}
        </span>
      </div>
    </div>
  );
};

export default FileInput;
